<!-- 由 woniu6162 创建于 2020-12-03 星期四 -->
<template>
  <div v-if="!isSuccess" class="q-2020-reduce">
    <img :src="headPng" class="bg" />
    <!-- <div
      class="q2r_top"
      v-html="`为了确保您入营后的减脂效果<br/>请先准确填写一下问卷`"
    />-->
    <!-- 未登录 -->
    <div v-if="token">
      <pBox
        class="reduce-content"
        :list="baseList"
        :datum="baseDatum"
        @tapField="tapField"
        @tapAddress="tapAddress"
        @submit="submit"
      />
      <!-- popup弹出框 -->
      <ponentPopup :data="popupData" @confirm="popConfirm" />
      <addressPopup :data="popupData" @confirm="addressConfirm" />
    </div>
    <LoginComponent v-else @login="bindLoginSuccess" />
  </div>
  <pSuccess v-else />
</template>

<script>
import pBox from './ponents/p-box.vue'
import pSuccess from './ponents/p-success.vue'
import ponentPopup from './ponents/ponent-popup.vue'
import addressPopup from './ponents/p-address.vue'
import LoginComponent from './ponents/login.vue'
import Cookies from 'js-cookie'
export default {
  name: 'join-camp-question',

  mixins: [],

  components: { pBox, pSuccess, ponentPopup, addressPopup, LoginComponent },

  props: {},

  data() {
    return {
      token: '',
      userInfo: null,
      idName: 'pb_wt_item_',
      isSuccess: false,
      headPng:
        'https://cdnvue.gymcity.com.cn/uploads/3b2a0e47ae18355560e798127f0d8a47.png',
      baseDatum: {},
      baseList: null,
      curField: '',
      // 选择器弹框数据
      popupData: {
        show: false,
        showAddress: false,
        list: [],
        index: 1
      }
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {
    this.init()
  },

  destroyed() {},

  methods: {
    init() {
      this.signToken = this.$route.query.sign_token
      this.token = this.$route.query.token || Cookies.get('join-camp-token')
      // 没有自带减脂营token则走减脂营授权拿token
      if (!this.signToken && !this.token) {
        window.location.href = `https://btwx.gymcity.com.cn/wxAuth?auth=wegymer&scope=snsapi_userinfo&next=${encodeURIComponent(
          location.href
        )}`
      } else {
        /* 判断登录是否过期 */
        if (this.token) {
          this.getQuestionData()
        }
      }
    },
    async getUserInfo() {
      let params = {
        sign_token: this.signToken
      }
      let res = await this.$http.getApp('getWxUserInfo', params).catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 1) {
          for (let key in this.baseDatum) {
            if (key == 'nickname') {
              this.baseDatum[key] = res.data.nickname
            }
          }
        }
      }
    },
    // 加载初始数据
    async loadDatum() {
      let params = {
        token: this.token,
        fid: this.$route.query.fid,
        cid: this.$route.query.cid
      }
      let res = await this.$http.getBaseApp(
        'que/Questionnaire/initQuestion',
        params
      )
      if (res) {
        res = res.data
        if (res.code === 200) {
          let result = res.data
          this.baseList = this.filterResult(result)
          this.baseDatum = this.mapBase(result)
          this.$set(
            this.baseDatum,
            'phone',
            this.$route.query.phone ||
              this.userInfo?.phone ||
              Cookies.get('join-camp-question-phone')
          )
          if (this.$route.query.sfrom === 'campReserve') {
            this.$set(this.baseDatum, 'knows_from', '9')
          }
          this.getUserInfo()
        }
      }
    },
    // 初始化加载到的数据
    filterResult(data) {
      data.map((item) => {
        item.sub_list.map((item1) => {
          if (Array.isArray(item1.field_unit)) {
            let values = Array.isArray(item1.value)
              ? item1.value
              : [item1.value]
            item1.field_unit.map((item2) => {
              if (values.includes(item2.key)) {
                item2.isCheck = true
              } else {
                item2.isCheck = false
              }
            })
          }
        })
      })
      return data
    },
    // 提交按钮
    submit() {
      let emptyType = ''
      for (let i in this.baseDatum) {
        if (!decodeURIComponent(this.baseDatum[i])) {
          if (i === 'province' && this.baseDatum.region !== '3') {
          } else {
            emptyType = i
            this.$toast('请填写完整问卷！')
            for (let i = 0; i < this.baseList.length; i++) {
              let item = this.baseList[i].sub_list
              for (let j = 0; j < item.length; j++) {
                if (item[j].field === emptyType) {
                  document
                    .getElementById(this.idName + i + '_' + j)
                    .scrollIntoView() // 跳至未填写的题目
                  return
                }
              }
            }
          }
        }
        this.baseList.forEach((item) => {
          item.sub_list.forEach((sub) => {
            if (sub.field === i) {
              sub.value = this.baseDatum[i]
            }
          })
        })
      }
      this.$nextTick(() => {
        this.uploadDatum()
      })
    },
    //获取问卷基本信息
    getQuestionData() {
      this.loadDatum()
    },
    // 数据上传
    async uploadDatum() {
      let params = {
        sign_token: this.signToken,
        token: this.token,
        cid: this.$route.query.cid,
        info: JSON.stringify(this.baseList)
      }
      this.$toast.loading('提交问卷中··')
      let res = await this.$http
        .postBaseApp('que/Questionnaire/saveQuestion', params)
        .catch(() => {
          this.$toast('网络错误')
        })
      this.$toast.clear()
      if (res) {
        res = res.data
        if (res.code === 200) {
          // app预约点评跳转过来的
          if (this.$route.query.sfrom === 'campReserve') {
            this.$toast('提交成功，即将返回预约')
            setTimeout(() => {
              //  带标记参数 和 原有参数 并去掉token返回
              // 安卓replace失效 换用cookie方式
              // window.location.replace(
              //   this.$http._toBetterWeH5(`betterwe/reserve?isFillQues=1&${location.href.split('?')[1].replace('token', 'notoken')}`)
              // )
              Cookies.set('isFillQues', '1')
              window.history.go(-1)
            }, 1000)
          } else {
            this.isSuccess = true
          }
        } else {
          this.$toast(res.msg)
        }
      }
    },
    // picker-点击弹窗
    tapField(item) {
      this.curField = item.field
      this.popupData.show = true
      this.popupData.list = this.fDatum(item.field_unit)
    },
    // 省市地区选择弹框
    tapAddress(item) {
      this.curField = item.field
      this.popupData.showAddress = true
    },
    // picker-确认
    popConfirm(val) {
      this.popupData.show = false
      this.baseDatum[this.curField] = val.value
    },
    // 省市选择 确认
    addressConfirm(val) {
      this.popupData.showAddress = false
      this.baseDatum[this.curField] = val
    },
    // 格式化结构
    mapBase(arr) {
      let obj = {}
      arr.forEach((item) => {
        item.sub_list.forEach((sub) => {
          if (sub.field_type === 'checkbox') {
            obj[sub.field] = sub.value ? sub.value.split(',') : []
          } else {
            obj[sub.field] = sub.value
          }
        })
      })
      return obj
    },
    // 格式化下拉框选项
    fDatum(arr) {
      return arr.map((item) => {
        return {
          text: item.value,
          value: item.key
        }
      })
    },
    // 取cookie
    getCookie(name) {
      let arr = []
      let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
      if ((arr = document.cookie.match(reg))) return unescape(arr[2])
      else return null
    },
    //登录成功
    bindLoginSuccess(res) {
      this.userInfo = res
      let expires = new Date(new Date() * 1 + 1000 * 60 * 5) //设置5分钟过期
      Cookies.set('join-camp-question-phone', res.phone, { expires: expires })
      this.token = res.token
      Cookies.set('join-camp-token', res.token, { expires: expires })
      this.getQuestionData()
    }
  }
}
</script>

<style lang="scss" scoped>
.q-2020-reduce {
  box-sizing: border-box;
  min-height: 100vh;
  background: #fff;
  padding-bottom: 13vw;
  position: relative;
  z-index: 1;

  // position: relative;
  // z-index: 0;
  // padding: 66.4vw 5.3vw 13vw;
  & > img {
    width: 100%;
    object-fit: cover;
    // position: absolute;
    // z-index: -1;
    // top: 0;
    // left: 0;
  }

  .q2r_top {
    padding: 2.1vw 0;
    width: 73.3vw;
    margin: 0 auto;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 1.6vw;
    text-align: center;
    font-size: 4vw;
    line-height: 6.4vw;
    color: #000;
  }
}

.bg {
  position: relative;
  z-index: -1;
  margin-bottom: -35vw;
}
</style>
